export const TZ_COOKIE = "portal_tz";

/** All IANA zones the browser knows, for the settings picker. */
export function listTimeZones(): string[] {
  const fn = (Intl as unknown as { supportedValuesOf?: (k: string) => string[] }).supportedValuesOf;
  return fn ? fn("timeZone") : ["UTC"];
}
